import React from 'react';
import { Card } from 'react-bootstrap';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { getChartColor, largeNumberFormatter, formatQuarterYear } from '../utils/helpers'
import CustomTooltip from './CustomTooltip';

const MultiLineChart = ({ data }) => {
    const regions = data?.Data?.[0]?.Values.map(item => item.Name);
    return (
        <Card>
            <Card.Title style={{ textAlign: 'center', marginTop: 12 }}>{data?.Name}</Card.Title>
            <p style={{ textAlign: 'center', marginTop: 12, paddingLeft: 40, paddingRight: 40 }}>{data?.Description}</p>
            <Card.Body>
                <ResponsiveContainer width="100%" height={400} >
                    {data?.Data.length > 0 ? (
                        <LineChart data={data?.Data} >
                            <CartesianGrid vertical={false} />
                            <XAxis dataKey={(e) => e.XAxis} fontSize={12} angle={-40} dy={20} dx={-20} />
                            <YAxis fontSize={12} tickFormatter={largeNumberFormatter} />
                            <Tooltip content={<CustomTooltip showTotal={true} />} />
                            <Legend verticalAlign="bottom" wrapperStyle={{ paddingTop: "40px" }} />
                            {regions && regions.map((region, index) => (
                                <Line
                                    key={region}
                                    name={region}
                                    dataKey={(entry) => {
                                        const regionData = entry.Values.find((item) => item.Name === region);
                                        return regionData ? regionData.Value : 0;
                                    }}
                                    strokeWidth={4}
                                    stroke={getChartColor(index)}
                                    fill={getChartColor(index)}
                                />
                            ))}
                        </LineChart>
                    ) : (
                        <div style={{ display: 'flex', height: '100%', width: '100%', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', fontWeight: 500, }}>
                            No Data
                        </div>
                    )}
                </ResponsiveContainer>
            </Card.Body>
        </Card>
    );
};

export default MultiLineChart;